// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"72e58fbf","453":"db20094a","593":"1cd53cc9"}[chunkId] + ".chunk.js";
};